<div class="form-inline white">
<div class="pad30">
    <section class="container">
        <label class="form-title">{{'New school details'|translate}}</label>
        <label class="label-light">{{projectName}}</label>
    </section>

    <!-- <h6><strong>School Information</strong> <span class="pull-right marR20"><a (click)="editLink()" class="edit"><i class="glyphicon glyphicon-pencil"></i>&nbsp;&nbsp;Edit</a></span></h6>
    <hr> -->
<!--     <span class="pull-right marR20 edit-link"><a (click)="editLink()" class="edit"><i class="glyphicon glyphicon-pencil"></i>&nbsp;&nbsp;Edit</a></span>
 -->    
    <section class="row flexStart marT15">
        <div class="labelwid"><label class="label-light">{{'School name'|translate}}</label> </div>
        <div class="txtW"><label class="labeltxt">{{data.name}}</label></div>
    </section>

    <section class="row flexStart marT15">
        
        <div class="labelwid"><label class="label-light">{{'Address' | translate }}</label> </div>
        <div class="txtW"><label class="labeltxt">{{data.contact?.address}}</label></div>
    </section>

      <section class="row flexStart marT15">        
        <div class="labelwid"><label class="label-light">{{'Region' | translate }}</label> </div>
        <div class="txtW"><label class="labeltxt">{{data.region?.name}}</label></div>
    </section>

    <section class="row flexStart marT15">
        

        <div class="labelwid"><label class="label-light">{{'Category' | translate }}</label> </div>
        <div class="txtW"><label class="labeltxt">{{data?.category?.name}}</label></div>
        
    </section>
    <section class="row flexStart marT15">
        <div class="labelwid"><label class="label-light">{{'Phone no' | translate }}.</label> </div>
        <div class="txtW"><label class="labeltxt">{{data.contact?.phone}}</label></div>
    </section>
    <section class="row flexStart marT15">
        <div class="labelwid"><label class="label-light">{{'Website' | translate }}</label> </div>
        <div class="txtW"><label class="labeltxt">{{data.contact?.url}}</label></div>
        
    </section>

    <section class="row item-middle marT15">
       
        <div class="labelwid"><label class="label-light">{{'School logo' | translate}}</label> </div>
        <div class="txtW" >
                <img  *ngIf="data?.logo?.url" [src]="data?.logo?.url?.replace('<FILEBASEURL>', environment.msdpAPIBaseURL)" style="width: 80px;height: 80px;" class="img-circle img-responsive" alt=''>
                <label class="labeltxt opac-5"*ngIf="!data?.logo?.url">(n/a)</label>                    
        </div>
<!--         <div class="txtW" *ngIf="!data?.logo?.url"><label class="labeltxt opac-6">(n/a)</label></div>
 -->
    </section>
    <!-- <section class="container">
        <div class="one">Project</div>
        <div class="two">{{projectName}}</div>
    </section> -->
    <div class="h-line marT15"></div>
<!--     <span class="pull-right marR20 mart10 edit-link"><a (click)="editAdminLink()" class="edit"><i class="glyphicon glyphicon-pencil"></i>&nbsp;&nbsp;Edit</a></span>
 -->    <section class="row flexStart marT20 ">
        <div class="title">{{'School admin details' | translate}}</div>
    </section>
    <section class="row flexStart marT20">
       
        <div class="labelwid"><label class="label-light">{{'First names' | translate}}</label> </div>
        <div class="txtW"><label class="labeltxt">{{userData.first_name|ucfirst}}</label></div>
    </section>
    <section class="row flexStart marT15">
       
        <div class="labelwid"><label class="label-light">{{'Surname' | translate}}</label> </div>
        <div class="txtW"><label class="labeltxt">{{userData.last_name|ucfirst}}</label></div>
    </section>
    <section class="row flexStart marT15">
       
        <div class="labelwid"><label class="label-light">{{'Email address' | translate}}</label> </div>
        <div class="txtW"><label class="labeltxt">{{userData.contact.email}}</label></div>
    </section>
</div>
</div>
